import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/tipoDesconto/';

class TipoDescontoService{
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findTipoDescontoByFiltro(idCliente, filtro){
        return axios.get(API_URL + 'allTipoDesconto?idCliente='+idCliente+'&filtro='+filtro, {headers: this.headers});
    }

    getTipoDesconto(id){
        return axios.get(API_URL + id, {headers: this.headers});
    }

    saveTipoDesconto(tipoDesconto){
        return axios.post(API_URL, JSON.stringify(tipoDesconto), {headers: this.headers});
    }

    removeTipoDesconto(id){
        return axios.delete(API_URL + id, {headers: this.headers});
    }
}

export default new TipoDescontoService();